import { Group, Modal, ThemeIcon, Title } from '@mantine/core'
import { useGlobalState } from '@opsopti/shared'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useLocation } from 'wouter'

import { theme } from '@/configs/theme'
import * as classes from '@/styles/TableModals.css'

export const TableModals = observer(function TableModals() {
  const [pathname] = useLocation()
  const { uiStore } = useGlobalState()

  useEffect(() => {
    uiStore.closeTableModal({ closeAll: true })
  }, [pathname])

  const disableCloseOverride = !!uiStore.formDrawers.find(({ Component }) => !!Component) || uiStore.isEditingTableCell

  return Array.from({ length: Math.max(uiStore.tableModals.length, 10) }, (_v, i) => uiStore.tableModals[i] ?? {}).map(
    ({ Component, ComponentProps, ModalProps, TitleProps }, index) => {
      return (
        <Modal
          key={index}
          size={2600}
          keepMounted
          centered
          withCloseButton
          closeOnClickOutside={disableCloseOverride ? false : true}
          closeOnEscape={disableCloseOverride ? false : true}
          opened={!!Component}
          transitionProps={{ duration: 0 }}
          onClose={uiStore.closeTableModal}
          classNames={classes.modal}
          {...ModalProps}
          title={
            !!TitleProps ? (
              <Group wrap="nowrap" align="center">
                <ThemeIcon variant="filled" size={theme.rem(36)}>
                  {TitleProps.Icon && <TitleProps.Icon />}
                </ThemeIcon>
                <Title order={6} fw={500}>
                  {TitleProps.title}
                </Title>
              </Group>
            ) : (
              (ModalProps?.title ?? null)
            )
          }>
          {!!Component && <Component {...ComponentProps} />}
        </Modal>
      )
    },
  )
})
